import FormattedMessage from 'I18n/components/FormattedMessage';
import { LockedIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TLSEncryptionText = () => {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "tls-encryption-text",
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "center",
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(LockedIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.protectedByTLS"
      })]
    })
  });
};
export default TLSEncryptionText;